const contact = {
  hero: {
    title: "Contáctanos",
    subtitle: "¡Respondemos rápido — generalmente en 2 horas!",
    methods: [
      { icon: "ri-phone-line", label: "Llamar / Texto", value: "(561) 262-6118" },
      { icon: "ri-whatsapp-line", label: "WhatsApp", value: "Escríbenos" },
      { icon: "ri-mail-line", label: "Email", value: "adrimich7778@hotmail.com" },
    ],
  },
  form: {
    title: "Envíanos un Mensaje",
    subtitle: "Completa el formulario y te responderemos pronto.",
    fields: {
      name: "Nombre Completo",
      email: "Correo Electrónico",
      phone: "Número de Teléfono",
      service: "Servicio Necesario",
      message: "Mensaje",
      date: "Fecha Preferida",
      messagePlaceholder: "Cuéntanos sobre tus necesidades...",
      serviceOptions: [
        "Limpieza Residencial",
        "Limpieza Profunda",
        "Limpieza de Mudanza",
        "Limpieza Airbnb",
        "Reparación de Drywall",
        "Reparación de Puertas",
        "Reparación de Gabinetes",
        "Pintura Interior",
        "Instalación de TV",
        "Ensamblaje de Muebles",
        "Lavado a Presión",
        "Limpieza de Canaletas",
        "Reparación de Cercas",
        "Jardinería Pequeña",
        "Otro",
      ],
    },
    submit: "Enviar Mensaje",
    sending: "Enviando...",
    success: "¡Mensaje enviado! Te contactaremos pronto.",
    error: "Algo salió mal. Por favor intenta de nuevo.",
    responseTime: "Respondemos en 2 horas",
  },
  info: {
    title: "Información de Contacto",
    address: { label: "Dirección", value: "10639 Misty Lane, Royal Palm Beach, FL 33411" },
    phone: { label: "Teléfono / Texto / WhatsApp", value: "(561) 262-6118" },
    email: { label: "Email", value: "adrimich7778@hotmail.com" },
    schedule: { label: "Horario de Atención", value: "Lun – Sáb: 8:00 AM – 4:00 PM" },
    payment: { label: "Métodos de Pago", value: "Efectivo · Zelle · Cheque" },
  },
  faq: {
    title: "Preguntas Frecuentes",
    items: [
      { q: "¿Qué tan rápido responden?", a: "Generalmente respondemos en 2 horas durante el horario de atención. Para solicitudes urgentes, llámanos o envíanos un texto directamente." },
      { q: "¿Ofrecen cotizaciones gratis?", a: "¡Sí! Todas las cotizaciones son completamente gratuitas. Contáctanos y evaluaremos tus necesidades para darte un estimado justo." },
      { q: "¿Qué áreas sirven?", a: "Servimos Royal Palm Beach, Wellington, West Palm Beach, Palm Beach Gardens, Lake Worth y áreas cercanas en el Condado de Palm Beach." },
      { q: "¿Qué métodos de pago aceptan?", a: "Aceptamos Efectivo, Zelle y Cheque. El pago se realiza al completar el servicio." },
      { q: "¿Están asegurados?", a: "Sí, somos un negocio familiar profesional y confiable. Contáctanos para más detalles sobre nuestra cobertura." },
      { q: "¿Trabajan los fines de semana?", a: "¡Sí! Trabajamos de lunes a sábado, de 8:00 AM a 4:00 PM." },
    ],
  },
};

export default contact;
